import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ThermometerWidgetModel } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { GbPresenterColorResolverService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-color-resolver.service'
@Component({
  selector: 'gb-presenter-widget-thermometer',
  imports: [CommonModule],
  templateUrl: './gb-presenter-widget-thermometer.component.html',
  styleUrl: './gb-presenter-widget-thermometer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetThermometerComponent {
  private _thermometerWidget: ThermometerWidgetModel | null = null

  constructor(private colorResolver: GbPresenterColorResolverService) {}

  @Input() testData: boolean = false
  @Input() set thermometerWidget(value: ThermometerWidgetModel) {
    this._thermometerWidget = value
  }

  get thermometerWidget(): ThermometerWidgetModel | null {
    return this._thermometerWidget
  }

  get hasImage(): boolean {
    return !!this.thermometerWidget?.custom_image
  }

  get imageUrl(): string | null {
    return this.thermometerWidget?.custom_image?.image ?? null
  }

  get rawPercentage(): number {
    if (this.testData) {
      return 75
    }
    const progress = this.thermometerWidget?.fundraising_progress
    const value = Number.isFinite(progress as number) ? Number(progress) : 0
    const pct = Math.round(value * 100)
    return Math.max(0, Math.min(100, pct))
  }

  get percentage(): string {
    return `${this.rawPercentage}%`
  }

  get inversePercentage(): string {
    return `${100 - this.rawPercentage}%`
  }

  get clipInset(): string {
    return `inset(${this.inversePercentage} 0 0 0)`
  }

  get thermometerBackgroundColor(): string {
    const color = this.thermometerWidget?.thermometer_background_color
    if (color === '' || !color) return 'transparent'
    return this.colorResolver.resolve(color) || 'transparent'
  }

  get thermometerBorderColor(): string {
    return this.colorResolver.resolve(this.thermometerWidget?.thermometer_border_color) || '#263238'
  }

  get thermometerColor(): string {
    return this.colorResolver.resolve(this.thermometerWidget?.thermometer_color) || '#F44336'
  }
}
